import React from 'react';
import '../Service/Service.css';
import img1 from "../../img/img1.jpg";
import img2 from "../../img/img2.jpg";
import img3 from "../../img/img3.jpg";
import img4 from "../../img/img4.jpg";
import img5 from "../../img/img5.jpg";
import img6 from "../../img/img6.jpg";
import img7 from "../../img/img7.jpg";
import img8 from "../../img/img8.jpg";


function Service() {
  return (

    <div className="container py-5">
      <h2 className="section-title " style={{color:'#cf6511'}}>RAJUCATERERS SIGNATURE DISHES</h2>

      <div id="dishCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="row">
              <div className="col-md-3 col-6">
                <div className="zoom-img">
                  <img src={img1} className="d-block w-100" alt="Dish 1" />
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="zoom-img">
                  <img src={img2} className="d-block w-100" alt="Dish 2" />
                </div>
              </div>
              <div className="col-md-3 col-6 d-none d-md-block">
                <div className="zoom-img">
                  <img src={img3} className="d-block w-100" alt="Dish 3" />
                </div>
              </div>
              <div className="col-md-3 col-6 d-none d-md-block">
                <div className="zoom-img">
                  <img src={img4} className="d-block w-100" alt="Dish 4" />
                </div>
              </div>
            </div>
          </div>

          <div className="carousel-item">
            <div className="row">
              <div className="col-md-3 col-6">
                <div className="zoom-img">
                  <img src={img5} className="d-block w-100" alt="Dish 5" />
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="zoom-img">
                  <img src={img6} className="d-block w-100" alt="Dish 6" />
                </div>
              </div>
              <div className="col-md-3 col-6 d-none d-md-block">
                <div className="zoom-img">
                  <img src={img7} className="d-block w-100" alt="Dish 7" />
                </div>
              </div>
              <div className="col-md-3 col-6 d-none d-md-block">
                <div className="zoom-img">
                  <img src={img8} className="d-block w-100" alt="Dish 8" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Controls */}
        <button className="carousel-control-prev" type="button" data-bs-target="#dishCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#dishCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>

      {/* <a href="#" className="view-btn">VIEW MORE</a> */}
    </div>
  );
}

export default Service;
